import { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { fontSizes, fontWeights } from '@opallabs/pulsar'

export const containerStyles: CSSObject = {
  inlineSize: '204px',
  blockSize: '32px',
  boxSizing: 'border-box',
  borderBlockStart: '2px solid #e6ebf0',
  display: 'flex',
  marginInlineStart: '5px',
  borderRadius: '2px',

  '.kuiper-create-new-from-post': {
    inlineSize: '100%',
  },

  'button:not([disabled]):hover': {
    backgroundColor: `${Color.light.Surface.A200} !important`,
    color: `${Color.light.Text.InvertedDefault} !important`,
  },

  '.kuiper-label': {
    justifyContent: 'flex-start !important',
  },
}

export const getButtonStyles = (disabled: boolean): CSSObject => ({
  backgroundColor: 'transparent',
  color: disabled ? Color.light.Text.Gray : Color.light.Text.Default,
  textTransform: 'inherit',
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.bold,
  blockSize: '28px',
  margin: 0,
  inlineSize: '100%',
  paddingInlineStart: '8px',
})
